import { render, staticRenderFns } from "./TableContracts.vue?vue&type=template&id=2981a31d&scoped=true&"
import script from "./TableContracts.vue?vue&type=script&lang=js&"
export * from "./TableContracts.vue?vue&type=script&lang=js&"
import style0 from "./TableContracts.vue?vue&type=style&index=0&id=2981a31d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981a31d",
  null
  
)

export default component.exports